export default __webpack_public_path__ + "static/media/00.aa2ce819.jpg";